import { Input } from 'antd';
import styled from 'styled-components';

export const NormInput = styled(Input)`
  width: 120px;
`;

export const PlannedResourceContainer = styled.div`
  .planned-resource-row {
    .hover-visible {
      opacity: 0;
      transition: 0.3s opacity;
    }

    &:hover {
      .hover-visible {
        opacity: 1;
      }
    }
  }
`;
